if (!customElements.get('dly-cart-suggest')) {
  customElements.define(
    'dly-cart-suggest',
    class DlyCartSuggest extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const button = event.target.closest('.dly-suggest__add');
        if (!button || button.disabled) return;

        const error = button.closest('.dly-suggest__item').querySelector('.dly-suggest__error');
        const drawer = document.querySelector('cart-drawer');
        button.disabled = true;
        error.textContent = '';

        // _dly_suggest stays out of the cart and emails (leading underscore) and marks the
        // line on the order, so the suggestion can be counted without guessing.
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify({
          id: Number(button.dataset.variantId),
          quantity: 1,
          properties: { _dly_suggest: button.dataset.kind },
          sections: drawer.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        });

        fetch(routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              error.textContent = response.description || window.cartStrings.error;
              button.disabled = false;
              return;
            }
            // The cart page has two sections to redraw and Dawn only refreshes one of them
            if (window.location.pathname === routes.cart_url) {
              window.location.reload();
              return;
            }
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'dly-cart-suggest',
              productVariantId: button.dataset.variantId,
              cartData: response,
            });
            drawer.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
            error.textContent = window.cartStrings.error;
            button.disabled = false;
          });
      }
    }
  );
}
